"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormImportPoleforemanModal = void 0;
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var modal_form_component_1 = require("../../components/modal.form/modal.form.component");
var spinner_1 = require("../../components/spinner/spinner");
var theme_1 = require("../../components/theme");
var i18n_1 = require("../../i18n");
var mithril_1 = require("../../mithril");
var services_1 = require("../../services");
var store_1 = require("../../store");
var FormImportPoleforemanModalCSS = {
    form: 'c-FormImportPoleforemanModal__form',
    spinner: 'c-FormImportPoleforemanModal__spinner'
};
(0, theme_1.addStyles)((_a = {},
    _a[FormImportPoleforemanModalCSS.form] = {
        display: 'flex',
        'flex-direction': 'column',
        gap: '10px',
        width: '400px',
        height: '80px'
    },
    _a[FormImportPoleforemanModalCSS.spinner] = {
        display: 'flex',
        'flex-direction': 'column',
        gap: '10px',
        'justify-content': 'center',
        'text-align': 'center'
    },
    _a));
var FormImportPoleforemanModal = /** @class */ (function (_super) {
    tslib_1.__extends(FormImportPoleforemanModal, _super);
    function FormImportPoleforemanModal(ctx, existingFormVersion) {
        var _this = _super.call(this, ctx) || this;
        _this.existingFormVersion = existingFormVersion;
        _this.loadingDatabases = false;
        _this.loadedDatabases = false;
        _this.loadingOperatingCompanies = false;
        _this.loadedOperatingCompanies = false;
        _this.attachmentId = null;
        _this.operatingCompany = null;
        _this.databaseURL = null;
        _this.databases = [];
        _this.operatingCompanies = [];
        _this.errorMessage = null;
        _this.displayCancelButton = false;
        _this.displaySubmitButton = false;
        _this.refreshDatabases();
        return _this;
    }
    FormImportPoleforemanModal.prototype.customButtons = function () {
        var _this = this;
        return [
            (0, mithril_1.m)('button', { className: 'mdl-button', onclick: function () { return _this.close(); }, disabled: this.loading, type: 'button' }, (0, i18n_1.Translate)(i18n_1.T.CANCEL)),
            (0, mithril_1.m)('button', {
                className: 'mdl-button mdl-button--accent', disabled: this.errorMessage || this.loading || !this.databaseURL, onclick: function () {
                    _this.refreshOperatingCompanies();
                }
            }, (0, i18n_1.Translate)(i18n_1.T.NEXT))
        ];
    };
    Object.defineProperty(FormImportPoleforemanModal.prototype, "nodes", {
        get: function () {
            var _this = this;
            if (this.errorMessage) {
                return (0, mithril_1.m)('div', {}, [(0, i18n_1.Translate)(this.errorMessage)]);
            }
            if (this.loadingDatabases) {
                return (0, mithril_1.m)('div', { className: FormImportPoleforemanModalCSS.spinner }, [(0, mithril_1.m)('div', (0, i18n_1.Translate)(i18n_1.T.FORM_IMPORT_POLEFOREMAN_FETCHING_ORGS)), spinner_1.Spinner.view()]);
            }
            if (this.loadingOperatingCompanies) {
                return (0, mithril_1.m)('div', { className: FormImportPoleforemanModalCSS.spinner }, [(0, mithril_1.m)('div', (0, i18n_1.Translate)(i18n_1.T.FORM_IMPORT_POLEFOREMAN_FETCHING_OP_CO)), spinner_1.Spinner.view()]);
            }
            // If we have databases loaded, but haven't selected the operating company yet, then display the database org selector
            if (this.loadedDatabases && !this.loadedOperatingCompanies) {
                return mithril_1.m.fragment({}, [(0, mithril_1.m)('form', { className: FormImportPoleforemanModalCSS.form }, this.databases.length > 0 ? [
                        (0, mithril_1.m)('div', [(0, i18n_1.Translate)(i18n_1.T.FORM_IMPORT_POLEFOREMAN_DESCRIPTION)]),
                        (0, mithril_1.m)('select', {
                            onchange: function (e) {
                                if ('target' in e && e.target && 'value' in e.target && typeof e.target.value === 'string') {
                                    _this.databaseURL = e.target.value;
                                    _this.isSubmitButtonDisabled = false;
                                }
                            }
                        }, tslib_1.__spreadArray([
                            (0, mithril_1.m)('option', { value: '', selected: true, disabled: true }, (0, i18n_1.Translate)(i18n_1.T.FORM_IMPORT_POLEFOREMAN_SELECT_ORG))
                        ], this.databases.map(function (db) { return (0, mithril_1.m)('option', { value: db.databaseURL }, db.organizationName); }), true))
                    ] : (0, mithril_1.m)('div', [(0, i18n_1.Translate)(i18n_1.T.FORM_IMPORT_POLEFOREMAN_NO_DATABASES)]))]);
            }
            if (this.loadedOperatingCompanies) {
                if (this.operatingCompanies.length === 1) {
                    return (0, mithril_1.m)('div', {}, [(0, i18n_1.Translate)(i18n_1.T.FORM_IMPORT_POLEFOREMAN_SINGLE_OP_CO, this.operatingCompanies[0].name)]);
                }
                return (0, mithril_1.m)('form', { className: FormImportPoleforemanModalCSS.form }, this.operatingCompanies.length > 0 ? [
                    (0, mithril_1.m)('div', [(0, i18n_1.Translate)(i18n_1.T.FORM_IMPORT_POLEFOREMAN_OP_CO_DESCRIPTION)]),
                    (0, mithril_1.m)('select', {
                        onchange: function (e) {
                            if ('target' in e && e.target && 'value' in e.target && typeof e.target.value === 'string') {
                                _this.operatingCompany = e.target.value;
                                _this.isSubmitButtonDisabled = false;
                            }
                        },
                        disabled: this.loading
                    }, tslib_1.__spreadArray([
                        (0, mithril_1.m)('option', { value: '', selected: true, disabled: true }, (0, i18n_1.Translate)(i18n_1.T.FORM_IMPORT_POLEFOREMAN_SELECT_OP_CO))
                    ], this.operatingCompanies.map(function (op) { return (0, mithril_1.m)('option', { value: op.id }, op.name); }), true))
                ] : (0, mithril_1.m)('div', [(0, i18n_1.Translate)(i18n_1.T.FORM_IMPORT_POLEFOREMAN_NO_OPERATING_COMPANIES)]));
            }
            return spinner_1.Spinner.view();
        },
        enumerable: false,
        configurable: true
    });
    FormImportPoleforemanModal.prototype.importPoleForemanForm = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var rest, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        this.setLoading(true);
                        rest = services_1.Services.Department.rest;
                        return [4 /*yield*/, rest.Form.Pla.importPoleforeman(tslib_1.__assign(tslib_1.__assign({ attachmentId: this.attachmentId }, (this.operatingCompany && { operatingCompanyId: parseInt(this.operatingCompany) })), (this.existingFormVersion && { existingFormVersion: this.existingFormVersion })))];
                    case 1:
                        _a.sent();
                        this.close();
                        store_1.AppStore.FormSummary.refresh();
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        this.handleError(i18n_1.T.FORM_IMPORT_POLEFOREMAN_ERROR_CREATION);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FormImportPoleforemanModal.prototype.submit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.importPoleForemanForm()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    FormImportPoleforemanModal.prototype.refreshOperatingCompanies = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result, e_2;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        this.displayCustomButtons = false;
                        this.loadingOperatingCompanies = true;
                        return [4 /*yield*/, services_1.Services.Department.rest.Form.Pla.savePoleForemanDb(tslib_1.__assign({}, (this.databaseURL && { databaseURL: this.databaseURL })))];
                    case 1:
                        result = _a.sent();
                        this.attachmentId = result.attachmentId;
                        this.operatingCompanies = result.operatingCompanies.map(function (op) { return ({
                            id: op.id,
                            name: op.name
                        }); });
                        if (this.operatingCompanies.length === 1) {
                            this.operatingCompany = this.operatingCompanies[0].id.toString();
                            this.importPoleForemanForm();
                        }
                        else {
                            this.isSubmitButtonDisabled = true;
                        }
                        return [3 /*break*/, 4];
                    case 2:
                        e_2 = _a.sent();
                        this.handleError(i18n_1.T.FORM_IMPORT_POLEFOREMAN_ERROR_OP_CO);
                        return [3 /*break*/, 4];
                    case 3:
                        this.displayCancelButton = true;
                        this.displaySubmitButton = true;
                        this.loadingOperatingCompanies = false;
                        this.loadedOperatingCompanies = true;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FormImportPoleforemanModal.prototype.refreshDatabases = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result, e_3;
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, 3, 4]);
                        this.displayCustomButtons = true;
                        this.loadingDatabases = true;
                        this.isSubmitButtonDisabled = true;
                        if (!((_a = services_1.Services.SSO.user) === null || _a === void 0 ? void 0 : _a.sub)) {
                            throw new Error('User not logged in');
                        }
                        return [4 /*yield*/, services_1.Services.User.rest.User.ipfDatabases({ userId: services_1.Services.SSO.user.sub })];
                    case 1:
                        result = _b.sent();
                        this.databases = result.databases;
                        this.loadedDatabases = true;
                        this.isSubmitButtonDisabled = true;
                        if (this.databases.length === 1) {
                            this.databaseURL = this.databases[0].databaseURL;
                            this.refreshOperatingCompanies();
                        }
                        return [3 /*break*/, 4];
                    case 2:
                        e_3 = _b.sent();
                        this.handleError(i18n_1.T.FORM_IMPORT_POLEFOREMAN_ERROR_DATABASE);
                        return [3 /*break*/, 4];
                    case 3:
                        this.loadingDatabases = false;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FormImportPoleforemanModal.prototype.handleError = function (msg) {
        this.setLoading(false);
        this.errorMessage = msg;
        this.displayCustomButtons = true;
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], FormImportPoleforemanModal.prototype, "loadingDatabases", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FormImportPoleforemanModal.prototype, "loadedDatabases", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FormImportPoleforemanModal.prototype, "loadingOperatingCompanies", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FormImportPoleforemanModal.prototype, "loadedOperatingCompanies", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FormImportPoleforemanModal.prototype, "attachmentId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FormImportPoleforemanModal.prototype, "operatingCompany", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FormImportPoleforemanModal.prototype, "databaseURL", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FormImportPoleforemanModal.prototype, "databases", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FormImportPoleforemanModal.prototype, "operatingCompanies", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FormImportPoleforemanModal.prototype, "errorMessage", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], FormImportPoleforemanModal.prototype, "importPoleForemanForm", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FormImportPoleforemanModal.prototype, "refreshOperatingCompanies", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FormImportPoleforemanModal.prototype, "refreshDatabases", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FormImportPoleforemanModal.prototype, "handleError", null);
    return FormImportPoleforemanModal;
}(modal_form_component_1.ModalFormComponent));
exports.FormImportPoleforemanModal = FormImportPoleforemanModal;
//# sourceMappingURL=form.import.poleforeman.modal.js.map